import { defineMessages } from 'react-intl'

export default defineMessages({
  error: {
    id: 'Console.ErrorLoading',
    defaultMessage: 'There was an error loading the Workgrid Console'
  },
  noPermissions: {
    id: 'Console.NoPermissions',
    defaultMessage: 'You do not have permissions to the Workgrid Console'
  },
  space: {
    id: 'Space:',
    defaultMessage: 'Space:'
  },
  subTitle: {
    id: 'HomePage.SubTitle',
    defaultMessage:
      'The Workgrid Console empowers you with effective tools and resources so you can keep your employees informed and engaged with relevant, timely and contextual information.'
  },
  title: {
    id: 'HomePage.Title',
    defaultMessage: "Welcome to the Workgrid Console.\nIt's you, but now with superpowers."
  },
  noSpace: {
    id: 'NoSpace',
    defaultMessage: 'No Space Access'
  },
  spaces: {
    id: 'Spaces',
    defaultMessage: 'Spaces'
  },
  addToSpace: {
    id: 'HomePage.addToSpaceAdmin',
    defaultMessage:
      'You do not have roles in any space. You can gain access to space features by adding yourself as a space administrator in {orgSpacesLink}.'
  },
  // Greetings
  goodMorning: {
    id: 'HomePage.goodMorning',
    defaultMessage: 'Good morning'
  },
  goodAfternoon: {
    id: 'HomePage.goodAfternoon',
    defaultMessage: 'Good afternoon'
  },
  goodEvening: {
    id: 'HomePage.goodEvening',
    defaultMessage: 'Good evening'
  },
  // Links
  whatsNewTitle: {
    id: 'HomePage.WhatsNew.Title',
    defaultMessage: "What's new"
  },
  whatsNewDescription: {
    id: 'HomePage.WhatsNew.Description',
    defaultMessage: 'Check out the latest features and enhancements'
  },
  whatsNewCallToAction: {
    id: 'HomePage.WhatsNew.CallToAction',
    defaultMessage: 'Read the blog'
  },
  gettingStartedTitle: {
    id: 'HomePage.GettingStarted.Title',
    defaultMessage: 'Getting started'
  },
  gettingStartedDescription: {
    id: 'HomePage.GettingStarted.Description',
    defaultMessage: 'Learn how to make your digitial workplace experience a success'
  },
  gettingStartedCallToAction: {
    id: 'HomePage.GettingStarted.CallToAction',
    defaultMessage: 'View the guide'
  },
  feedbackTitle: {
    id: 'HomePage.Feedback.Title',
    defaultMessage: 'Feedback'
  },
  feedbackDescription: {
    id: 'HomePage.Feedback.Description',
    defaultMessage: 'Help us continue to improve by submitting thoughts and ideas'
  },
  feedbackCallToAction: {
    id: 'HomePage.Feedback.CallToAction',
    defaultMessage: 'Submit feedback'
  },
  // Apps
  appsName: {
    id: 'HomePage.Apps.Name',
    defaultMessage: 'Name'
  },
  appsCreatedAt: {
    id: 'HomePage.Apps.CreatedAt',
    defaultMessage: 'Created'
  },
  appsCreatedBy: {
    id: 'HomePage.Apps.CreatedBy',
    defaultMessage: 'Creator'
  },
  appsModifiedAt: {
    id: 'HomePage.Apps.ModifiedAt',
    defaultMessage: 'Last updated'
  },
  appsModifiedBy: {
    id: 'HomePage.Apps.ModifiedBy',
    defaultMessage: 'Last modified'
  },

  getStartedGuide: {
    id: 'HomePage.Cards.GetStarted',
    defaultMessage: 'Get started guide'
  },
  getStartedDetail: {
    id: 'HomePage.Cards.GetStarted.Detail',
    defaultMessage: 'Start here if you’re new or just need a refresher on all things Console.'
  },

  tryAssistant: {
    id: 'HomePage.Cards.TryAssistant',
    defaultMessage: 'Try the Assistant'
  },
  tryAssistantDetail: {
    id: 'HomePage.Cards.TryAssistant.Detail',
    defaultMessage: 'Use the Playground to chat and see notifications'
  },
  installAppsDetail: {
    id: 'HomePage.Cards.InstallApps.Detail',
    defaultMessage: 'Browse and customize prebuilt templates'
  },

  addUsers: {
    id: 'HomePage.Cards.AddUsers',
    defaultMessage: 'Add users'
  },
  addUsersDetail: {
    id: 'HomePage.Cards.AddUsers.Detail',
    defaultMessage: 'Share Workgrid with your team'
  },

  sendNotifications: {
    id: 'HomePage.Cards.SendNotifications',
    defaultMessage: 'Send notifications'
  },
  sendNotificationsDetail: {
    id: 'HomePage.Cards.SendNotifications.Detail',
    defaultMessage: 'Schedule and target custom notifications'
  },

  integrations: {
    id: 'HomePage.Cards.Integrations',
    defaultMessage: 'Integrate with data'
  },
  integrationsDetail: {
    id: 'HomePage.Cards.Integrations.Detail',
    defaultMessage: 'Connect to third-party source systems'
  },
  needHelp: {
    id: 'HomePage.Hero.Help',
    defaultMessage: 'Need help?'
  },
  subHeading: {
    id: 'HomePage.SubTitle',
    defaultMessage: 'Integrate, communicate, automate & more'
  },
  subtitleSubtext: {
    id: 'HomePage.SubTitleSubtext',
    defaultMessage: 'Whether you’re new to Workgrid or need a refresher, we’ve got you covered.'
  },
  tutorials: {
    id: 'HomePage.Tutorials',
    defaultMessage: 'Watch tutorials'
  },
  whatsNew: {
    id: 'HomePage.WhatsNew',
    defaultMessage: "What's new"
  },
  knowledgeSources: {
    id: 'HomePage.KnowledgeSources',
    defaultMessage: 'Recent knowledge sources'
  },
  audience: {
    id: 'HomePage.KnowledgeSources.Audience',
    defaultMessage: 'Audience'
  },
  ownedBy: {
    id: 'HomePage.KnowledgeSources.Owner',
    defaultMessage: 'Owned by'
  },
  knowledgeTooltip: {
    id: 'HomePage.KnowledgeSources.Tooltip',
    defaultMessage: 'Uploaded documents can be used as knowledge for the AI Assistant, targeted to specific audiences.'
  },
  seeAll: { id: 'HomePage.MyApps.SeeAll', defaultMessage: 'See all' },
  loading: {
    id: 'HomePage.LoadingDocuments',
    defaultMessage: 'Loading...'
  },
  shareFeedback: {
    id: 'HomePage.ShareFeedback',
    defaultMessage: 'Share feedback'
  },
  uploadADocument: {
    id: 'HomePage.UploadADocument',
    defaultMessage: 'Upload a document'
  },
  browseTemplates: {
    id: 'HomePage.BrowseTemplates',
    defaultMessage: 'Browse templates'
  }
})
